export default __webpack_public_path__ + "static/Hack-BoldItalic-319b23493960c1c13740a8e185ad93e8.woff2";